import { createReducer } from "../../common/reduxUtil";
import { NOTIFICATIONS } from "../common/constants";

import {
  RECEIVED_NOTIFICATION,
  NEW_NOTIFICATIONS,
  LOAD_NEW_NOTIFICATIONS,
  SET_SHOW_NOTIFICATION_PERMISSION_MODAL,
  NOTIFICATION_TITLE,
  SET_SHOW_HUDDLE_NOTIFICATION,
  SET_SHOW_KICK_NOTIFICATION,
} from "./types";

const initialState = {
  NOTIFICATIONS,
  NEW_NOTIFICATIONS,
  showNotificationPermissionModal: false,
  title: "Notifications",
  subTitle: "",
  showHuddleNotification: false,
  huddleNotificationData: null,
  showKickNotification: false,
  kickNotificationData: null,
};

export default createReducer(initialState, {
  [RECEIVED_NOTIFICATION]: (state, payload) => {
    return Object.assign({}, state, {
      notifications: payload,
    });
  },
  [NEW_NOTIFICATIONS]: (state, payload) => {
    return Object.assign({}, state, {
      newNotifications: payload,
    });
  },
  [LOAD_NEW_NOTIFICATIONS]: (state, payload) => {
    return Object.assign({}, state, {
      loadNewNotifications: payload,
    });
  },
  [SET_SHOW_NOTIFICATION_PERMISSION_MODAL]: (state, payload) => {
    return Object.assign({}, state, {
      showNotificationPermissionModal: payload,
    });
  },
  [SET_SHOW_HUDDLE_NOTIFICATION]: (state, payload) => {
    return Object.assign({}, state, {
      showHuddleNotification: payload.show,
      ...(payload.data && { huddleNotificationData: payload.data }),
    });
  },
  [SET_SHOW_KICK_NOTIFICATION]: (state, payload) => {
    return Object.assign({}, state, {
      showKickNotification: payload.show,
      ...(payload.data && { kickNotificationData: payload.data }),
    });
  },
  [NOTIFICATION_TITLE]: (state, payload) => {
    return Object.assign({}, state, {
      title: payload,
    });
  },
});
